// Teinte du badge de TYPE d'artefact (cahier §3.3.8, P4) : le serveur nomme le type du
// visuel, seule l'interface connaît sa couleur. Type de visuel (contrat C0) → type du
// dictionnaire de teintes, jetons --ds-art-<type>-* (index.css). Module pur, sans JSX :
// lu par typeBadge.jsx (badge et icône) et par la suite E2E des visuels.

export const ART_TYPES = {
  line: 'courbe',
  area: 'courbe',
  bar: 'histogramme',
  stacked_bar: 'histogramme',
  horizontal_bar: 'histogramme',
  grouped_horizontal_bar: 'histogramme',
  pie: 'camembert',
  donut: 'camembert',
  gauge: 'jauge',
  kpi_cards: 'kpi',
  reliability_cards: 'kpi',
  ranking: 'classement',
  heatmap: 'heatmap',
  scatter: 'scatter',
  waterfall: 'cascade',
  table: 'table',
  markers: 'carte',
  heat: 'carte',
  route: 'carte',
  trace: 'carte',
  zones: 'carte',
  planning: 'planning',
  embed: 'web',
  // Galerie de photos d'un véhicule (v1.13) : fichiers des liens vérifiés, teinte des contenus web
  photos: 'web',
};

// Format d'un document généré → type du dictionnaire (teintes des formats, --ds-doc-*)
const DOCUMENT_TYPES = { pdf: 'pdf', docx: 'word', doc: 'word', word: 'word', xlsx: 'excel', xls: 'excel', excel: 'excel', pptx: 'ppt', ppt: 'ppt', powerpoint: 'ppt' };

/** Type du dictionnaire d'un document (format « pdf », « docx »…), ou null. */
export function documentArtType(format) {
  const key = typeof format === 'string' ? format.trim().toLowerCase().replace(/^\./, '') : '';
  return DOCUMENT_TYPES[key] ?? null;
}
